<template>
    <div class="NavsPage">
        <div class="NavsPage__row">
            <div class="NavsPage__example">
                <h5>Reports Sidebar</h5>
                <RPSidebar
                    :tabs="reports"
                    active-tab="Overview"
                    dynamic-tab="Dynamic Tab"
                />
            </div>
            <div class="NavsPage__example">
                <h5>Reports Sidebar</h5>
                <RPSidebar
                    :tabs="reports"
                    status="loading"
                    active-tab="Overview"
                />
            </div>
            <div class="NavsPage__example">
                <h5>Lists Sidebar</h5>
                <RPSidebar
                    :tabs="lists"
                    active-tab="Entries"
                />
            </div>
            <div class="NavsPage__example">
                <h5>Lists Sidebar</h5>
                <RPSidebar
                    :tabs="lists"
                    status="loading"
                    active-tab="Entries"
                />
            </div>
        </div>
        <div class="NavsPage__row">
            <div class="NavsPage__example">
                <h5>Reports Sidebar</h5>
                <RPTopbar
                    :tabs="reports"
                    active-tab="Overview"
                />
            </div>
            <div class="NavsPage__example">
                <h5>Lists Sidebar</h5>
                <!-- <RPTopbar
                    :tabs="lists"
                    active-tab="Reviews"
                /> -->
            </div>
        </div>
    </div>
</template>

<script>
import RPSidebar from 'components/Complex/Navs/RPSidebar.vue';
import RPTopbar from 'components/Complex/Navs/RPTopbar.vue';

export default {
    components: {
        RPSidebar,
        RPTopbar
    },
    data() {
        return {
            dynamicTab: 'Brand 1',
            reports: [
                {
                    header: 'Collective Reports',
                    subTabs: [
                        {
                            to: {name: "Overview"},
                            label: 'Overview',
                        },
                        {
                            to: {name: "Locations"},
                            label: 'Locations',
                        },
                        {
                            to: {name: "Sentiment"},
                            label: 'Sentiment',
                        },
                        {
                            to: {name: "Competitors"},
                            label: 'Competitors',
                        },
                        {
                            to: {name: "Google Insights"},
                            label: 'Google Insights',
                        },
                    ],
                },
                {
                    header: 'Focused Reports',
                    subTabs: [
                        {
                            to: {name: "Reviews"},
                            label: 'Reviews',
                        },
                        {
                            to: {name: "Ratings"},
                            label: 'Ratings',
                        },
                        {
                            to: {name: "Keywords"},
                            label: 'Keywords',
                        },
                        {
                            to: {name: "Landing Pages"},
                            label: 'Landing Pages',
                        },
                        {
                            to: {name: "Campaigns"},
                            label: 'Campaigns',
                        },
                        {
                            to: {name: "Review Responses"},
                            label: 'Review Responses',
                        },
                    ],
                },
            ],
            lists: [
                {
                    to: {name: "Entries"},
                    label: 'Entries',
                },
                {
                    to: {name: "Integrations"},
                    label: 'Integrations',
                },
                {
                    to: {name: "Campaigns"},
                    label: 'Campaigns',
                },
                {
                    to: {name: "Settings"},
                    label: 'Settings',
                },
            ],
        };
    },
};
</script>

<style lang="scss">
    .NavsPage{
        height: 100%;
        width: 100%;
        padding: 50px;
        background: #E5E5E5;
        &__row {
            display: flex;
            justify-content: space-evenly;
            margin-bottom: 4rem;
        }
    }
</style>
